import React from 'react';
import { DevCycleProvider } from '@devcycle/react-client-sdk';
import { getIsDevCycleAvailable } from 'src/hooks/useDevCycleAdapter';

interface ConditionalDevCycleProviderProps {
  sdkKey?: string;
  children: React.ReactNode;
}

/**
 * Conditionally wraps children with DevCycleProvider if DevCycle is available.
 * This allows the app to gracefully handle environments where DevCycle is not configured.
 *
 * @param sdkKey - The DevCycle SDK key. If undefined, children are rendered without the provider.
 * @param children - React children to be wrapped
 */
export const ConditionalDevCycleProvider = ({
  sdkKey,
  children,
}: ConditionalDevCycleProviderProps): JSX.Element => {
  const isDevCycleAvailable = getIsDevCycleAvailable();

  if (!isDevCycleAvailable) {
    return <>{children}</>;
  }

  return <DevCycleProvider config={{ sdkKey }}>{children}</DevCycleProvider>;
};
